import {
  Button,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
} from '@one-thd/sui-atomic-components';
import { DateTime } from 'luxon';
import React, { useState } from 'react';
import { useCommonContext } from '../../../hooks/useContexts';
import { IPHRequest } from '../../../models/purchase-history';
import { ISortAndSearchButton } from '../../../models/purchase-history/sort-and-search';
import { CustomDateRange } from '../../shared/CustomDateRange';
import { DateSelectionDropdown } from '../../shared/DateSelectionDropdown';
import { SearchBy, SortBy } from './index';

const isApplyDisabled = (
  startDate: DateTime | null,
  endDate: DateTime | null,
) => {
  if (
    (startDate?.toISODate() || '') === '' &&
    (endDate?.toISODate() || '') === ''
  )
    return true;
  if (
    startDate &&
    startDate?.startOf('day') <
      DateTime.now().minus({ months: 25 }).startOf('day')
  )
    return true;
  if (endDate && endDate?.startOf('day') > DateTime.now().startOf('day'))
    return true;
  return false;
};

export const SortAndSearchButton = ({
  customerType,
  dateSelectorValue,
  isMobile,
  pHRequest,
  setDateSelectorValue,
  setPHRequest,
}: ISortAndSearchButton) => {
  const [open, setOpen] = useState(false);
  const [drawerStepper, setDrawerStepper] = useState(0);

  const [startDate, setStartDate] = useState<DateTime | null>(null);
  const [endDate, setEndDate] = useState<DateTime | null>(null);

  const { setDateRangeOptions } = useCommonContext();

  const dateRangeState = {
    startDate,
    endDate,
    open,
    setEndDate,
    setStartDate,
    dateSelectorValue,
    setOpen,
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button variant="primary" onClick={() => handleOpen()}>
        Sort & Search
      </Button>
      <Drawer open={open} onClose={handleClose} style={{ zIndex: 2000000009 }}>
        {drawerStepper === 0 ? (
          <DrawerHeader title="Sort & Search" onClose={handleClose} />
        ) : (
          <DrawerHeader
            title="Custom Date Range"
            onClose={() => {
              handleClose();
              setDrawerStepper(0);
            }}
            onBack={() => {
              setDateSelectorValue('recentOrders');
              setDrawerStepper(0);
            }}
          />
        )}
        <DrawerBody>
          <div style={{ minHeight: 400 }}>
            {drawerStepper === 0 && (
              <>
                <div className="sui-pb-[24px]">
                  <SortBy
                    pHRequest={pHRequest}
                    setPHRequest={setPHRequest}
                    handleClose={handleClose}
                  />
                </div>
                <div className="sui-pb-[24px]">
                  <DateSelectionDropdown
                    label="View History From"
                    dateSelectorValue={dateSelectorValue}
                    setDateSelectorValue={setDateSelectorValue}
                    setPHRequest={setPHRequest}
                    enableFullWidth
                    handleModalClose={handleClose}
                    setDrawerStepper={setDrawerStepper}
                  />
                </div>
                <SearchBy
                  customerType={customerType}
                  pHRequest={pHRequest}
                  setPHRequest={setPHRequest}
                  isMobile={isMobile}
                  handleClose={handleClose}
                />
              </>
            )}
            {drawerStepper === 1 && (
              <CustomDateRange dateRangeState={dateRangeState} />
            )}
          </div>
        </DrawerBody>
        {drawerStepper === 1 && (
          <DrawerFooter position="end">
            <div className="sui-flex sui-flex-col sui-gap-4">
              <Button
                variant="primary"
                disabled={isApplyDisabled(startDate, endDate)}
                onClick={() => {
                  if (setDateRangeOptions) {
                    setDateRangeOptions({
                      startDate: startDate?.toISODate() || '',
                      endDate: endDate?.toISODate() || '',
                    });
                    if (setPHRequest) {
                      setPHRequest((prevState: IPHRequest) => {
                        return {
                          ...prevState,
                          startDate: startDate?.toISODate() || '',
                          endDate: endDate?.toISODate() || '',
                          pageNumber: 1,
                        };
                      });
                    }
                    setDrawerStepper(0);
                    setOpen(false);
                  }
                }}
              >
                Apply
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  setStartDate(null);
                  setEndDate(null);
                }}
              >
                Clear
              </Button>
            </div>
          </DrawerFooter>
        )}
      </Drawer>
    </>
  );
};
